import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import PromotionBuilder from "./PromotionBuilder";

const Promotions = () => {
  document.title = "Promotions | Susipizza";

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title="susipizza" breadcrumbItem="Promotions" />
        <PromotionBuilder />
      </Container>
    </div>
  );
};

export default Promotions;
